import axios from "axios";

export default axios.create({
  baseURL:
    process.env.REACT_APP_ENV === "PROD"
      ? "https://bookingjini.info/jiniassist_api"
      : "https://staging.chatbot.bookingjini.info",
});
